export default (state = [], action) => {
	switch (action.type) {
		case "FETCH_MANAGERS_FULFILLED":
			return action.payload;
		default:
			return state;
	}
};
